import { doc, increment } from 'firebase/firestore';
import { firestore } from '../firebaseConfig';

// Builds the counts_by_level patch for a given item type.
// Words: { words: { [level]: ±1 } }
// Sentences: { sentences_by_wk: { [level]: { [wk]: ±1 } } }
const buildLevelCountPatch = (itemType, level, kanjiComplexity, delta) => {
  if (itemType === 'sentences') {
    return {
      sentences_by_wk: {
        [level]: { [kanjiComplexity]: increment(delta) },
      },
    };
  }
  return { [itemType]: { [level]: increment(delta) } };
};

// Get update operations for adding a new item.
// For sentences, kanjiComplexity (0–61) MUST be supplied so the wk bucket gets incremented.
export const getAddItemStatsUpdates = (batch, userId, itemType, level, srsStage = 0, skipped = false, kanjiComplexity = null) => {
  const levelRef = doc(firestore, 'users', userId, 'metadata', 'counts_by_level');
  const srsRef = doc(firestore, 'users', userId, 'metadata', 'counts_by_srs');

  batch.set(levelRef, buildLevelCountPatch(itemType, level, kanjiComplexity, 1), { merge: true });

  // Update counts by SRS stage (skipped items go to 'skipped' key)
  const srsUpdate = {
    [itemType]: {}
  };
  if (skipped) {
    srsUpdate[itemType].skipped = increment(1);
  } else {
    srsUpdate[itemType][srsStage] = increment(1);
  }
  batch.set(srsRef, srsUpdate, { merge: true });
};

// Get update operations for removing an item.
// For sentences, kanjiComplexity (0–61) MUST be supplied.
export const getRemoveItemStatsUpdates = (batch, userId, itemType, level, srsStage, skipped = false, correctCount = 0, wrongCount = 0, kanjiComplexity = null) => {
  const levelRef = doc(firestore, 'users', userId, 'metadata', 'counts_by_level');
  const srsRef = doc(firestore, 'users', userId, 'metadata', 'counts_by_srs');
  const accuracyRef = doc(firestore, 'users', userId, 'metadata', 'review_accuracy');

  batch.set(levelRef, buildLevelCountPatch(itemType, level, kanjiComplexity, -1), { merge: true });

  // Update counts by SRS stage
  const srsUpdate = {
    [itemType]: {}
  };
  if (skipped) {
    srsUpdate[itemType].skipped = increment(-1);
  } else {
    srsUpdate[itemType][srsStage] = increment(-1);
  }
  batch.set(srsRef, srsUpdate, { merge: true });

  // Update accuracy stats (decrement by the amounts this item contributed)
  if (correctCount > 0 || wrongCount > 0) {
    const accuracyUpdate = {
      [itemType]: {}
    };
    if (correctCount > 0) {
      accuracyUpdate[itemType].correct = increment(-correctCount);
    }
    if (wrongCount > 0) {
      accuracyUpdate[itemType].wrong = increment(-wrongCount);
    }
    batch.set(accuracyRef, accuracyUpdate, { merge: true });
  }
};
